import React from "react";

const VerticalNavbar = ({ setDashboardMode }) => {
  return (
    <div className="VerticalNavbar">
      <div
        className="VerticalNavbarItems"
        onClick={() => {
          setDashboardMode("roadmapView");
        }}
      >
        Roadmaps
      </div>
      <div
        className="VerticalNavbarItems"
        onClick={() => {
          setDashboardMode("profileView");
        }}
      >
        Profile
      </div>
      <div
        className="VerticalNavbarItems"
        onClick={() => {
          setDashboardMode("statisticsView");
        }}
      >
        Statistics
      </div>
      <div
        className="VerticalNavbarItems"
        onClick={() => {
          setDashboardMode("collectionView");
        }}
      >
        Collections
      </div>
    </div>
  );
};

export default VerticalNavbar;
